import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import Select from 'react-select';
import { GET_VACATIONS } from '../queries';

const VacationDoctorSelector = props => {
  const {
    onChange,
    approvalStatus,
    vacationFrom,
    vacationTo,
    placeholder
  } = props;

  return (
    <Query
      query={GET_VACATIONS}
      variables={{ approvalStatus, vacationFrom, vacationTo }}
      fetchPolicy="network-only"
    >
      {({ loading, data: { getVacations = [] } = {} }) => {
        const doctors = {};
        (getVacations || []).forEach(({ entityId, entityName }) => {
          if (entityId && !doctors[entityId]) {
            doctors[entityId] = { entityId, name: entityName };
          }
        });
        const options = Object.values(doctors)
          .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
          .map(d => ({ label: d.name, value: d }));
        return (
          <Select
            isClearable
            options={options}
            isLoading={loading}
            onChange={onChange}
            placeholder={placeholder}
          />
        );
      }}
    </Query>
  );
};

VacationDoctorSelector.propTypes = {
  onChange: PropTypes.func,
  approvalStatus: PropTypes.string,
  vacationFrom: PropTypes.object,
  vacationTo: PropTypes.object,
  placeholder: PropTypes.string
};

export default VacationDoctorSelector;
